import {Component} from '@angular/core';

@Component({
    selector: 'acabim-admin-spaces',
    templateUrl: './bim.component.html',
    styleUrls: ['./bim.component.scss']
})
export class BimComponent {


}
